__turbopack_context__.v({
  "buttons-container": "devicesList-module-scss-module__g9uMKq__buttons-container",
  "fade-in-unwkr4d": "devicesList-module-scss-module__g9uMKq__fade-in-unwkr4d",
  "meter-list": "devicesList-module-scss-module__g9uMKq__meter-list",
  "meter-list-header": "devicesList-module-scss-module__g9uMKq__meter-list-header",
  "report": "devicesList-module-scss-module__g9uMKq__report",
  "toggle": "devicesList-module-scss-module__g9uMKq__toggle",
  "toggle-border": "devicesList-module-scss-module__g9uMKq__toggle-border",
  "toggle-button": "devicesList-module-scss-module__g9uMKq__toggle-button",
  "toggle-button-selected": "devicesList-module-scss-module__g9uMKq__toggle-button-selected",
  "wrapper": "devicesList-module-scss-module__g9uMKq__wrapper",
});
